<script>
    import bulmaCollapsible from '@creativebulma/bulma-collapsible';

    export default {
		props: {
			groups: Array,
			filterGroups: Array,
			groupLabel: String,
		},
		methods: {
			toggleGroup(groupName) {
				this.$emit('filter-group', groupName);
			},
		},
		updated() {
            if (!this.$refs.filter) return;
            this.$refs.filter.forEach($collapsible => {
                if (window.getComputedStyle($collapsible).height != '0px') bulmaCollapsible.attach($collapsible);
            });
        },
	};
</script>

<template>
	<div v-if="groups.length" class="filtering">
		<p class="title is-5 has-text-text mb-3">{{ groupLabel }}</p>
		<div class="field">
			<template v-for="group in groups" :key="group.Id">
				<div class="control mb-2 is-flex is-align-items-center">
					<input name="checkbox"
						   type="checkbox"
						   :id="group.Id"
						   class="by-checkbox"
						   :value="group.Naam"
						   :checked="filterGroups.includes(group.Naam)"
						   @change="toggleGroup(group.Naam)" />
					<label :for="group.Id" class="by-checkable">{{ group.Naam }}</label>
					<a v-if="group.Subdoelgroepen.length"
					   :href="`#collapse-${group.Id}`"
					   data-action="collapse"
					   class="collapse-trigger is-borderless is-hoverless ml-auto p-0">
						<span class="icon is-rounded"><i class="fa-solid fa-plus"></i></span>
					</a>
				</div>
				<div v-if="group.Subdoelgroepen.length" 
					 class="is-collapsible" 
					 :id="`collapse-${group.Id}`"
					 ref="filter">
					<template v-for="subgroup in group.Subdoelgroepen" :key="subgroup.Id">
						<div class="control mb-2 ml-4">
							<input name="checkbox"
								   type="checkbox"
								   :id="subgroup.Id"
								   class="by-checkbox"
								   :value="subgroup.Naam"
								   :checked="filterGroups.includes(subgroup.Naam)"
								   @change="toggleGroup(subgroup.Naam)" />
							<label :for="subgroup.Id" class="by-checkable">{{ subgroup.Naam }}</label>
						</div>
					</template>
				</div>
			</template>
		</div>
	</div>
</template>
